<section class="notification-list">
  @if (showHeader) {
    <header class="notification-list__header">
      <div class="notification-list__copy">
        <strong class="notification-list__title">{{ title }}</strong>
        <span class="notification-list__count">
          {{ notifications.length }} item(ns)
        </span>
      </div>

      @if (showActions && notifications.length) {
        <div class="notification-list__actions">
          <button
            type="button"
            class="notification-list__action"
            (click)="markAllAsRead()"
          >
            Marcar lidas
          </button>
          <button
            type="button"
            class="notification-list__action"
            (click)="clearAll()"
          >
            Limpar
          </button>
        </div>
      }
    </header>
  }

  @if (notifications.length) {
    <div class="notification-list__items">
      @for (notification of notifications; track notification.id) {
        <div class="notification-list__entry">
          <button
            type="button"
            class="notification-list__entry-card"
            (click)="openNotification(notification)"
          >
            <lib-ui-notification-item
              [notification]="notification"
              [compact]="compact"
            ></lib-ui-notification-item>
          </button>

          @if (showActions && hasOrderAction(notification)) {
            <div class="notification-list__entry-footer">
              <button
                type="button"
                class="notification-list__entry-action"
                (click)="openOrder(notification)"
              >
                Abrir pedido
              </button>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <lib-ui-notification-empty-state
      [title]="emptyTitle"
      [description]="emptyDescription"
    ></lib-ui-notification-empty-state>
  }
</section>
